import { deletePayment } from "common/services/payments.service";
import Permission from "Components/Common/Permission";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import UpdatePayment from "../UpdatePayment";
import DeleteModal from "Components/Common/DeleteModal";

const PaymentHeader = ({
  payment,
  fetchData,
}: {
  payment: any;
  fetchData: () => {};
}) => {
  const navigate = useNavigate();
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const showUpdateModalForm = () => {
    setIsUpdateModalOpen(true);
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const [deleting, setDeleting] = useState(false);
  const handleDelete = async () => {
    setDeleting(true);
    try {
      await deletePayment(payment?.id);

      setDeleting(false);
      setDeleteModal(false);
      navigate("/payments");
      toast.success("Payment deleted successfully");
    } catch (e: any) {
      toast.error("Error while deleting payment");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <CardHeader className="border-bottom-dashed p-4">
      <div className="flex-shrink-0 mt-sm-0 mt-3">
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0 me-3">
            <div className="avatar-sm">
              <div className="avatar-title bg-primary-subtle text-danger rounded fs-24">
                <i className="ri-bank-line text-primary"></i>
              </div>
            </div>
          </div>
          <div className="flex-grow-1">
            <h5 className="fs-14 mb-1" style={{ whiteSpace: "pre-wrap" }}>
              <Link to={`#`} className="text-body">
                {payment?.mda?.name || ""}
                {payment?.mda?.acronym ? ` (${payment?.mda?.acronym})` : ""}
              </Link>
            </h5>
            <p className="text-muted mb-0">
              <span className="fw-medium">
                {payment?.mda?.region?.name || ""}
              </span>
            </p>
          </div>
          <div className="flex-shrink-0 mt-sm-0 mt-3">
            <UncontrolledDropdown className="float-end">
              <DropdownToggle
                tag="a"
                className="btn py-0 fs-13 material-shadow-none align-middle  text-primary"
                role="button"
              >
                Actions
                <i className=" ri-arrow-down-s-fill fs-16 ms-1"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <Permission action="update" resource="individual">
                  <DropdownItem
                    href="#"
                    className="edit-item-btn"
                    onClick={(e: any) => {
                      e.preventDefault();
                      showUpdateModalForm();
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                    Edit
                  </DropdownItem>
                </Permission>
                <Permission action="delete" resource="individual">
                  <DropdownItem
                    href="#"
                    className="remove-item-btn"
                    onClick={(e: any) => {
                      e.preventDefault();
                      setDeleteModal(true);
                    }}
                  >
                    <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                    Delete
                  </DropdownItem>
                </Permission>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      </div>
      <UpdatePayment
        toggle={() => setIsUpdateModalOpen((state) => !state)}
        isModalOpen={isUpdateModalOpen}
        selectedRecord={payment}
        fetchData={fetchData}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => handleDelete()}
        onCloseClick={() => setDeleteModal(false)}
        loading={deleting}
      />
    </CardHeader>
  );
};

export default PaymentHeader;
